import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { Logout } from 'core/Store/auth/actions';

export default function() {
  const [, dispatch] = useSubstate(() => null);

  useEffect(() => {
    dispatch(new Logout());
  }, [dispatch]);

  return null;
}
